/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { invitationsControllerBulkCreate } from "./invitationsControllerBulkCreate";
import { invitationsControllerCreate } from "./invitationsControllerCreate";
import { invitationsControllerEditTargets } from "./invitationsControllerEditTargets";
import { invitationsControllerFindAll } from "./invitationsControllerFindAll";
import { invitationsControllerFindOne } from "./invitationsControllerFindOne";
import { invitationsControllerGetPermissions } from "./invitationsControllerGetPermissions";
import { invitationsControllerRemove } from "./invitationsControllerRemove";
import { invitationsControllerResend } from "./invitationsControllerResend";
import { invitationsControllerUpdate } from "./invitationsControllerUpdate";

export function invitationsService() {
  return { invitationsControllerCreate, invitationsControllerFindAll, invitationsControllerBulkCreate, invitationsControllerFindOne, invitationsControllerUpdate, invitationsControllerRemove, invitationsControllerGetPermissions, invitationsControllerEditTargets, invitationsControllerResend }
}